import React from 'react';
import BiometricEnrollment from './components/admin/BiometricEnrollment';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import AdminLayout from './components/admin/AdminLayout';
import ProtectedAdminRoute from './components/admin/ProtectedAdminRoute';
import AdminDashboard from './pages/admin/AdminDashboard';
import DeviceProvisioning from './pages/admin/DeviceProvisioning';
import UserManagement from './pages/admin/UserManagement';
import Timesheets from './pages/admin/Timesheets';
import Payroll from './pages/admin/Payroll';
import Companies from './pages/admin/Companies';
import AdminLogin from './pages/admin/AdminLogin';

function App() {
  const localLab = process.env.NODE_ENV === 'development'
    && process.env.REACT_APP_API_BASE_URL === 'http://127.0.0.1:18083'
    && ['localhost', '127.0.0.1'].includes(window.location.hostname);
  return (
    <Routes>
      {localLab ? <Route path="/local-enrollment" element={<main className="admin-shell min-h-screen p-8"><div className="mx-auto max-w-3xl"><h1 className="mb-6 text-3xl font-semibold">Local kiosk lab</h1><BiometricEnrollment employeeId="00000000-0000-4000-8000-000000000002" clientId="00000000-0000-4000-8000-000000000001" onClose={() => { window.location.href = '/'; }} /></div></main>} /> : null}
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route element={<ProtectedAdminRoute />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="companies" element={<Companies />} />
          <Route path="workforce" element={<UserManagement />} />
          <Route path="users" element={<Navigate to="/admin/workforce" replace />} />
          <Route path="devices" element={<DeviceProvisioning />} />
          <Route path="tracking" element={<Timesheets />} />
          <Route path="payroll" element={<Payroll />} />
          <Route path="settings" element={<div className="p-8 text-slate-500">System settings coming soon...</div>} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
